export default __webpack_public_path__ + "static/global-874975dfb89a05495e59e444d9e4c99c.png";